import { IconOptions } from 'primereact/utils';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const TrainSelected = (options: IconOptions) => {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...options.iconProps}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8.46216 1.00675C6.0511 1.16118 4.59107 1.62846 3.77133 2.50805C3.35886 2.95064 3.11917 3.46462 3.03501 4.0868C3.01118 4.26303 2.9999 5.78315 3 8.8058C3.00013 13.7025 2.99601 13.5897 3.19564 14.1553C3.38116 14.681 3.76436 15.2148 4.20647 15.5636C4.64708 15.9111 5.26136 16.1577 5.78243 16.1962L6.05269 16.2162L5.40153 16.8843L4.7504 17.5525V17.7765V18.0005H5.73124H6.71209L7.5869 17.1032L8.46171 16.2059H10.0992H11.7367L12.6116 17.1032L13.4864 18.0005H14.37H15.2536V17.7765V17.5525L14.6024 16.8843L13.9513 16.2162L14.2215 16.1962C15.5736 16.0963 16.7401 14.9688 16.9576 13.5515C17.0001 13.2746 17.0053 12.6113 16.9962 8.61232L16.9858 3.99301L16.9145 3.71928C16.7593 3.12349 16.5499 2.74982 16.1529 2.36047C15.4245 1.646 14.3125 1.25728 12.4495 1.066C12.0671 1.02675 11.5007 1.01033 10.2937 1.00352C9.39334 0.998437 8.56914 0.9999 8.46216 1.00675ZM9.12671 6.35252V8.13045H6.95476H4.78281V6.35252V4.57458H6.95476H9.12671V6.35252ZM15.2211 6.35252V8.13045H13.0492H10.8772V6.35252V4.57458H13.0492H15.2211V6.35252ZM6.45463 11.8079C6.94053 11.9753 7.26513 12.366 7.34597 12.8807C7.48239 13.7492 6.71792 14.5338 5.88231 14.3829C5.19435 14.2586 4.75319 13.7014 4.78901 13.0019C4.81825 12.4308 5.16595 11.9751 5.7067 11.7994C5.89343 11.7387 6.26622 11.7429 6.45463 11.8079ZM14.4756 11.8731C15.1832 12.2127 15.4377 13.1065 15.0206 13.7865C14.5855 14.4957 13.594 14.6074 13.022 14.0117C12.3428 13.3042 12.6115 12.1511 13.5354 11.8084C13.6387 11.7701 13.7665 11.7568 13.9731 11.7631C14.2196 11.7705 14.2975 11.7875 14.4756 11.8731Z'
        fill='#27292D'
        fillOpacity='0.8'
      />
    </svg>
  );
};

export default TrainSelected;
